import React, { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Checkbox, FormControlLabel, Typography, Box
} from '@material-ui/core'

const SaveAsGlobalModal = ({ open, change, clientName, onSkip, onApply }) => {
  const [updateEntity, setUpdateEntity] = useState(false)
  const [updateClient, setUpdateClient] = useState(false)

  if (!change) return null

  const handleApply = () => {
    onApply({ updateEntity, updateClient })
    setUpdateEntity(false)
    setUpdateClient(false)
  }

  const handleSkip = () => {
    setUpdateEntity(false)
    setUpdateClient(false)
    onSkip()
  }

  return (
    <Dialog open={open} onClose={handleSkip} maxWidth="sm" fullWidth>
      <DialogTitle>Also update the global default?</DialogTitle>
      <DialogContent>
        <Typography variant="body1" style={{ marginBottom: 16 }}>
          You changed <strong>{change.roleName}</strong> from ${change.oldRate ?? '(default)'} to <strong>${change.newRate}</strong> for this bid.
        </Typography>
        <Box>
          <FormControlLabel
            control={<Checkbox checked={updateEntity} onChange={(e) => setUpdateEntity(e.target.checked)} />}
            label="Also update the entity default for future bids"
          />
        </Box>
        {clientName && (
          <Box>
            <FormControlLabel
              control={<Checkbox checked={updateClient} onChange={(e) => setUpdateClient(e.target.checked)} />}
              label={`Also update the client-specific rate for ${clientName}'s future bids`}
            />
          </Box>
        )}
        <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 16 }}>
          These changes do NOT affect other projects — they apply to future bids going forward.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSkip}>Skip</Button>
        <Button
          onClick={handleApply}
          variant="contained"
          color="primary"
          disabled={!updateEntity && !updateClient}
        >
          Apply Selected
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SaveAsGlobalModal
